export class AppException extends Error {
  constructor(message: string | undefined) {
    super(message);
    this.name = 'AppException';
  }
}
